const useAppRedirects = () => {
  if (window.location.pathname === '/register') {
    window.location.replace(process.env.REACT_APP_TRIGGER_REGISTER_FORM);
    return { redirected: true };
  }
  return { redirected: false };
};

export default useAppRedirects;
